import { useState, useEffect, useCallback } from "react";
import { useToast } from "@chakra-ui/react";
import { adminApi } from "../../../data/axios/adminApi";
import { AdminLeader } from "../../../types/admin";

const PAGE_SIZE = 20;

export function useLeadersAdmin() {
  const toast = useToast();
  const [leaders, setLeaders] = useState<AdminLeader[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [syncing, setSyncing] = useState(false);
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const fetchLeaders = useCallback(async () => {
    try {
      setLoading(true);
      setError(false);
      const data = await adminApi.listLeaders({ search: search || undefined, page, page_size: PAGE_SIZE });
      setLeaders(data.leaders);
      setTotalPages(data.total_pages);
    } catch {
      setError(true);
      toast({ title: "Erro ao carregar gestores", status: "error", duration: 4000, isClosable: true });
    } finally {
      setLoading(false);
    }
  }, [search, page, toast]);

  useEffect(() => { setPage(1); }, [search]);

  useEffect(() => {
    fetchLeaders();
  }, [fetchLeaders]);

  const handleSync = async () => {
    try {
      setSyncing(true);
      const result = await adminApi.syncLeaders();
      toast({
        title: `Sincronização concluída`,
        description: `${result.synced} gestor(es) sincronizado(s).`,
        status: "success",
        duration: 5000,
        isClosable: true,
      });
      await fetchLeaders();
    } catch {
      toast({ title: "Erro ao sincronizar gestores", status: "error", duration: 4000, isClosable: true });
    } finally {
      setSyncing(false);
    }
  };

  return {
    leaders,
    loading,
    error,
    syncing,
    search,
    setSearch,
    page,
    totalPages,
    setPage,
    handleSync,
    refreshList: fetchLeaders,
  };
}
